import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";
import { Link } from "react-router-dom";

const toTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

function Returns() {
  return (
    <div className="returns">
      <Header />
      <main role="main" id="MainContent" tabIndex={-1}>
        <div
          id="shopify-section-template--19428123902026__header_cms_4m6eyk"
          className="shopify-section"
        >
          <div className="page-width relative">
            <img
              src="/main/c1.webp"
              alt="Background image"
              className="absolute left-0 top-0 w-full h-full -z-1 object-cover"
              aria-hidden="true"
            />
            <div className="relative pt-19 pb-16 mx-5 lg:mx-20 lg:py-20.5">
              <h1 className="heading-2 text-center">Returns &amp; Exchanges</h1>
            </div>
          </div>
        </div>
        <div
          id="shopify-section-template--19428123902026__support_cta_grid_PrimwY"
          className="shopify-section"
        >
          <div className="page-width">
            <div className="page-width__inner is-support-page">
              <div className="pt-10 pb-7.5 md:pt-11 md:pb-10 ">
                <div className="mb-10">
                  <h2 className="p1-bold text-center mx-auto">
                    Our process in a nutshell.
                  </h2>
                </div>
                <div className="flex flex-wrap gap-y-12 max-md:px-5 md:flex-row">
                  <div className="flex flex-col items-stretch gap-4 shrink-0 group md:gap-5 md:w-1/3 md:px-2.5 w-full">
                    <div className="w-18 h-18 md:w-26.5 md:h-26.5 mx-auto">
                      <picture>
                        <img
                          className="w-full h-full rounded-full group-hover:scale-105 transition-transform duration-300 object-cover"
                          src="/main/r1-1.svg"
                          sizes="(min-width: 768px) 106px, 72px"
                          width={54}
                          height={54}
                          loading="lazy"
                          fetchpriority="auto"
                          alt=""
                          decoding="async"
                        />
                      </picture>
                    </div>
                    <h3 className="subheading-2-bold text-center md:subheading-1-bold">
                      Select Items to Return
                    </h3>
                  </div>
                  <div className="flex flex-col items-stretch gap-4 shrink-0 group md:gap-5 md:w-1/3 md:px-2.5 w-full">
                    <div className="w-18 h-18 md:w-26.5 md:h-26.5 mx-auto">
                      <picture>
                        <img
                          className="w-full h-full rounded-full group-hover:scale-105 transition-transform duration-300 object-cover"
                          src="/main/r1-2.svg"
                          sizes="(min-width: 768px) 106px, 72px"
                          width={54}
                          height={54}
                          loading="lazy"
                          fetchpriority="auto"
                          alt=""
                          decoding="async"
                        />
                      </picture>
                    </div>
                    <h3 className="subheading-2-bold text-center md:subheading-1-bold">
                      Get a Return Confirmation
                    </h3>
                  </div>
                  <div className="flex flex-col items-stretch gap-4 shrink-0 group md:gap-5 md:w-1/3 md:px-2.5 w-full">
                    <div className="w-18 h-18 md:w-26.5 md:h-26.5 mx-auto">
                      <picture>
                        <img
                          className="w-full h-full rounded-full group-hover:scale-105 transition-transform duration-300 object-cover"
                          src="/main/r1-3.svg"
                          sizes="(min-width: 768px) 106px, 72px"
                          width={54}
                          height={54}
                          loading="lazy"
                          fetchpriority="auto"
                          alt=""
                          decoding="async"
                        />
                      </picture>
                    </div>
                    <h3 className="subheading-2-bold text-center md:subheading-1-bold">
                      Stick It in the Mail
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="shopify-section-template--19428123902026__faq_accordion_mQUBUX"
          className="shopify-section"
        >
          <div className="page-width">
            <div className="page-width__inner is-support-page">
              <accordion-group className="flex flex-col gap-5 pt-10 pb-7.5 md:gap-10 md:pt-11 md:pb-10">
                <div className="js-accordion-group border-t-1 border-mist">
                  <div className="ac py-4 border-b-1 border-mist md:py-6">
                    <div className="ac-header ac-trigger flex justify-between gap-4">
                      <h4 className="subheading-1-bold">
                        What's your return policy?
                      </h4>
                    </div>
                    <div className="ac-panel transition-all">
                      <div className="prose faq-answer ac-text pt-2.5">
                        <p>
                          You can return or exchange pretty much anything for
                          365 days, no questions asked, except for a few things:
                        </p>
                        <ul>
                          <li>
                            Any item you didn't purchase from our website or a
                            Mindredlane store
                          </li>
                          <li>
                            Customized items: once you make it yours,
                            it's...yours.
                          </li>
                          <li>
                            Bathing suits that have been worn or are missing the
                            hygienic lining
                          </li>
                          <li>
                            Boxers and boxer briefs that have been worn or are
                            not in the original packaging
                          </li>
                          <li>
                            Final Sale items: Re-Spun Take Back Bag, Gift Cards,
                            Mystery Tees, and any items marked Final Sale
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="ac py-4 border-b-1 border-mist md:py-6">
                    <div className="ac-header ac-trigger flex justify-between gap-4">
                      <h4 className="subheading-1-bold">
                        How do I return an online order?
                      </h4>
                    </div>
                    <div className="ac-panel transition-all">
                      <div className="prose faq-answer ac-text pt-2.5">
                        <p>
                          You can use the link above! The shipping is free (free
                          for you, not for us) if you're in the U.S. We'll
                          refund you once we know that your return is in the
                          mail and on its way back to us. You can also return
                          online orders to any of our stores.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="ac py-4 border-b-1 border-mist md:py-6">
                    <div className="ac-header ac-trigger flex justify-between gap-4">
                      <h4 className="subheading-1-bold">
                        What about returning something I bought in a Marine
                        Layer store?
                      </h4>
                    </div>
                    <div className="ac-panel transition-all">
                      <div className="prose faq-answer ac-text pt-2.5">
                        <p>
                          It's easiest to return those items to one of our
                          stores, but if that doesn't work for you shoot us an
                          email (
                          <Link
                            onClick={toTop}
                            to="mailto:works@mindredlane.watch"
                          >
                            works@mindredlane.watch
                          </Link>
                          ) with your name and address and we'll get you a
                          prepaid label to ship it back to us.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="ac py-4 border-b-1 border-mist md:py-6">
                    <div className="ac-header ac-trigger flex justify-between gap-4">
                      <h4 className="subheading-1-bold">
                        How do I return or exchange a gift? (Don't worry, we
                        won't tell.)
                      </h4>
                    </div>
                    <div className="ac-panel transition-all">
                      <div className="prose faq-answer ac-text pt-2.5">
                        <p>
                          Click the "Got a Gift?" option and simply enter the
                          order number and shipping zip code. Then follow the
                          instructions. It's pretty easy, even by our standards.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="ac py-4 border-b-1 border-mist md:py-6">
                    <div className="ac-header ac-trigger flex justify-between gap-4">
                      <h4 className="subheading-1-bold">
                        How about if I don’t have a receipt or I got my items
                        from one of your awesome retail partners?
                      </h4>
                    </div>
                    <div className="ac-panel transition-all">
                      <div className="prose faq-answer ac-text pt-2.5">
                        <p>
                          If you don’t have proof of purchase, contact us{" "}
                          <Link onClick={toTop} to="/contact">
                            here
                          </Link>
                          &nbsp;and we’ll try our hardest to find the info you
                          need and figure out the best way for you to return it.
                          If you got your items from somewhere besides our
                          website or our stores, you’ll need to return it there
                          within the guidelines of their return policy.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="ac py-4 border-b-1 border-mist md:py-6">
                    <div className="ac-header ac-trigger flex justify-between gap-4">
                      <h4 className="subheading-1-bold">
                        What if I'm not in the U.S.?
                      </h4>
                    </div>
                    <div className="ac-panel transition-all">
                      <div className="prose faq-answer ac-text pt-2.5">
                        <p>
                          We love to travel as much as the next guy, but our
                          pre-paid return labels only cover shipments within the
                          U.S. Feel free to send your return to the below
                          address and we'll process it for you.
                          <br />
                          <br />
                          899 Powers Ferry Rd a24, Marietta, GA 30067 US
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="ac py-4 border-b-1 border-mist md:py-6">
                    <div className="ac-header ac-trigger flex justify-between gap-4">
                      <h4 className="subheading-1-bold">
                        Do you honor price adjustments?
                      </h4>
                    </div>
                    <div className="ac-panel transition-all">
                      <div className="prose faq-answer ac-text pt-2.5">
                        <p>
                          We may honor a one-time adjustment within 14 days of
                          your order/purchase date. If your order qualifies,
                          forward the confirmation email to{" "}
                          <Link
                            onClick={toTop}
                            to="mailto:works@mindredlane.watch"
                          >
                            works@mindredlane.watch{" "}
                          </Link>
                          and we'll take care of the rest!
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </accordion-group>
            </div>
          </div>
        </div>
        <div
          id="shopify-section-template--19428123902026__contact_us_nFEjjc"
          className="shopify-section"
        >
          <div className="page-width py-7.5 md:pt-10 md:pb-13">
            <div className="page-width__inner is-support-page">
              <div className="empty:hidden flex flex-col gap-2 md:gap-4 mb-7.5 md:mb-10 max-md:px-5">
                <h2 className="heading-3 mx-auto text-center max-w-[270px] md:max-w-[600px]">
                  Still Have Questions? Contact Us.
                </h2>
                <p className="subheading-2 text-center max-w-[644px] mx-auto">
                  Here's how to get in touch. <br /> Answering in real time
                  9am–5pm PT, Monday through Friday.
                </p>
              </div>
              <div className="flex flex-col justify-center gap-y-12 max-md:px-5 md:flex-row md:flex-wrap">
                <Link
                  onClick={toTop}
                  to="mailto:works@mindredlane.watch"
                  className="flex flex-col items-stretch gap-2 shrink-0 w-full cursor-pointer group md:gap-4.5 md:w-1/3 md:px-2.5"
                  aria-label="Email Us"
                >
                  <div className="w-18 h-18 md:w-26.5 md:h-26.5 mx-auto">
                    <picture>
                      <img
                        className="w-full h-full rounded-full group-hover:scale-105 transition-transform duration-300 object-cover"
                        src="/main/c2-1.svg"
                        sizes="(min-width: 768px) 106px, 72px"
                        width={54}
                        height={54}
                        loading="lazy"
                        fetchpriority="auto"
                        alt=""
                        decoding="async"
                      />
                    </picture>
                  </div>
                  <h3 className="subheading-1-bold text-center break-all">
                    Email Us
                  </h3>
                  <h4 className="subheading-2-bold text-center break-all ">
                    works@mindredlane.watch
                  </h4>
                  <p className="p1 max-w-76 mx-auto text-center">
                    This is the best and fastest way to reach us. Just send us a
                    note and we’ll get back to you within 24 hours.
                  </p>
                </Link>
                <Link
                  onClick={toTop}
                  to="tel:844.544.5199"
                  className="flex flex-col items-stretch gap-2 shrink-0 w-full cursor-pointer group md:gap-4.5 md:w-1/3 md:px-2.5"
                  aria-label="Text or Call Us"
                >
                  <div className="w-18 h-18 md:w-26.5 md:h-26.5 mx-auto">
                    <picture>
                      <img
                        className="w-full h-full rounded-full group-hover:scale-105 transition-transform duration-300 object-cover"
                        src="/main/c2-2.svg"
                        sizes="(min-width: 768px) 106px, 72px"
                        width={54}
                        height={54}
                        loading="lazy"
                        fetchpriority="auto"
                        alt=""
                        decoding="async"
                      />
                    </picture>
                  </div>
                  <h3 className="subheading-1-bold text-center break-all">
                    Text or Call Us
                  </h3>
                  <h4 className="subheading-2-bold text-center break-all ">
                    844.544.5199
                  </h4>
                  <p className="p1 max-w-76 mx-auto text-center">
                    Wanna talk to a real human? Shoot us a text or give us a
                    call.
                  </p>
                </Link>
                <chat-trigger className="flex flex-col items-stretch gap-2 shrink-0 w-full cursor-pointer group md:gap-4.5 md:w-1/3 md:px-2.5">
                  <div className="w-18 h-18 md:w-26.5 md:h-26.5 mx-auto">
                    <picture>
                      <img
                        className="w-full h-full rounded-full group-hover:scale-105 transition-transform duration-300 object-cover"
                        src="/main/c2-3.svg"
                        sizes="(min-width: 768px) 106px, 72px"
                        width={54}
                        height={54}
                        loading="lazy"
                        fetchpriority="auto"
                        alt=""
                        decoding="async"
                      />
                    </picture>
                  </div>
                  <h3 className="subheading-1-bold text-center break-all">
                    Chat With Us
                  </h3>
                  <h4 className="subheading-2-bold text-center break-all underline group-hover:text-slate">
                    Start a chat
                  </h4>
                  <p className="p1 max-w-76 mx-auto text-center">
                    You’ve got questions? We’ve got answers. Our bot’s on it.
                    and we’re here if things get sticky.
                  </p>
                </chat-trigger>
              </div>
            </div>
          </div>
        </div>
        <limespot />
      </main>

      <Footer />
    </div>
  );
}

export default Returns;
